$(".openbtn").click(function () {//ボタンがクリックされたら
  $(this).toggleClass('active');//ボタン自身に activeクラスを付与し
  $("#g-nav").toggleClass('panelactive');//ナビゲーションにpanelactiveクラスを付与
});

$("#g-nav a").click(function () {//ナビゲーションのリンクがクリックされたら
    $(".openbtn").removeClass('active');//ボタンの activeクラスを除去し
    $("#g-nav").removeClass('panelactive');//ナビゲーションのpanelactiveクラスも除去
});


document.addEventListener('DOMContentLoaded', () => {
  // 「買い物を続ける」のリンク要素を取得
  const continueShoppingLink = document.querySelector('.underlined-link');

  // リンク要素が存在する場合にリンク先を変更
  if (continueShoppingLink) {
    continueShoppingLink.href = 'https://na-hiroshima.com/products/course?variant=41778513051763';
  } else {
    console.error('「買い物を続ける」のリンクが見つかりません。');
  }
});